import React from "react";
import {
  DOCUMENT_TYPES,
  usePatientDocumentsQuery,
} from "../../../../../api/patientDocuments/usePatientDocumentsQuery";
import { uiNotification } from "../../../../../services/UINotificationService";
import { getPathParams } from "../utilities";

import { usePermission } from "../../../../../hooks/usePermission";

export const withDocumentTypes = (Component) => (props) => {
  var { patientId } = getPathParams();
  const { permitted: canManageMedicalHistory } = usePermission(
    "manage-medical-history",
  );

  var { data } = usePatientDocumentsQuery({
    payload: {
      pageSize: 15,
      patientId,
    },
    options: {
      staleTime: 0,
      cacheTime: 0,
      keepPreviousData: true,
      onError: () => {
        uiNotification.error(
          "Unable to fetch document types. Please try again later.",
        );
      },
    },
  });

  return (
    <Component
      {...props}
      documentTypes={(data?.pages?.[0]?.docTypes || []).filter(
        ({ value }) =>
          canManageMedicalHistory || value !== DOCUMENT_TYPES.medicalHistory,
      )}
    />
  );
};
